var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWorkspacePBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10,
    fill: "#E9EBED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6747 16.9375V21H11.8231V9.79688H15.2216C16.508 9.79688 17.5054 10.0964 18.2137 10.6953C18.9221 11.2943 19.2762 12.138 19.2762 13.2266C19.2762 14.3151 18.9065 15.2057 18.1669 15.8984C17.4273 16.5911 16.4273 16.9375 15.1669 16.9375H13.6747ZM13.6747 11.3281V15.4219H14.8778C15.6747 15.4219 16.2815 15.237 16.6981 14.8672C17.1148 14.4974 17.3231 13.9766 17.3231 13.3047C17.3231 11.987 16.5575 11.3281 15.0262 11.3281H13.6747Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkspacePBlack);
export default __webpack_public_path__ + "static/media/Icon_WorkspaceP_Black.506825d680c8aa0a07bdcb21e9d6dc45.svg";
export { ForwardRef as ReactComponent };